// import {
//   DECIMAL_PRECISION_STABLE_COIN,
//   DECIMAL_COEFFICIENT_STABLE_COIN,
//   DECIMAL_COEFFICIENT_UNSTABLE_COIN,
//   DECIMAL_PRECISION_UNSTABLE_COIN,
// } from '@libs/backend-common';
// TODO: tmp fix
export const formatPrice = (price) => {
    const numericPrice = typeof price === 'number' ? price : parseFloat(price);
    if (numericPrice < 1000)
        return numericPrice;
    const roundedPrice = Math.max(parseFloat(numericPrice.toFixed(2)), numericPrice);
    return roundedPrice.toLocaleString('en-US', { minimumFractionDigits: 2 });
};
export const formatBalance = (amount, isCrypto, fixedAmount) => {
    if (typeof amount === 'undefined') {
        return '0';
    }
    else if (typeof amount === 'string') {
        amount = +amount;
    }
    const determinedMinFractionDigits = isCrypto ? 4 : 2;
    return parseFloat(amount.toFixed(determinedMinFractionDigits)).toLocaleString('en-US', {
        minimumFractionDigits: fixedAmount != null ? fixedAmount : determinedMinFractionDigits,
    });
    // const roundingPrecision = isCrypto
    //   ? DECIMAL_PRECISION_UNSTABLE_COIN
    //   : DECIMAL_PRECISION_STABLE_COIN;
    // const roundingCoefficient = isCrypto
    //   ? DECIMAL_COEFFICIENT_UNSTABLE_COIN
    //   : DECIMAL_COEFFICIENT_STABLE_COIN;
    // const formattedAmount = (
    //   Math.floor(amount * roundingCoefficient) / roundingCoefficient
    // ).toLocaleString('en-US', { minimumFractionDigits: roundingPrecision });
    // return formattedAmount;
};
// NOTE: if price is <= 1, it returns price directly
// if price > 1 returns formatted balance
export const getDetailedFormatBalance = (amount, precision = 2) => {
    if (typeof amount === 'undefined')
        return '';
    if (+amount > 1) {
        return formatBalance(amount, undefined, precision);
    }
    else
        return amount.toString();
};
//# sourceMappingURL=balance.js.map